import { Platform } from 'react-native'

interface WebGlobal {
  history?: {
    replaceState?: (data: unknown, unused: string, url?: string | URL | null) => void
  }
  location?: {
    pathname?: string
    search?: string
    hash?: string
    origin?: string
  }
}

export function getAdminPasswordResetRedirectUrl() {
  const webGlobal = globalThis as WebGlobal

  if (Platform.OS === 'web' && webGlobal.location?.origin) {
    return webGlobal.location.origin
  }

  return 'chillout-merchant://password-reset'
}

export function hasAdminPasswordResetUrlError() {
  if (Platform.OS !== 'web') {
    return false
  }

  const webGlobal = globalThis as WebGlobal
  const hash = webGlobal.location?.hash
  if (!hash) {
    return false
  }

  const normalizedHash = hash.replace(/^#/, '')
  return normalizedHash.includes('error=') || normalizedHash.includes('error_code=')
}

export function hasAdminPasswordRecoveryUrl() {
  if (Platform.OS !== 'web') {
    return false
  }

  const webGlobal = globalThis as WebGlobal
  const hash = webGlobal.location?.hash
  if (!hash) {
    return false
  }

  const normalizedHash = hash.replace(/^#/, '')
  return normalizedHash.includes('access_token=') && normalizedHash.includes('type=recovery')
}

// Newer Supabase reset-link format: ?token_hash=...&type=recovery as query
// params, no hash fragment — distinct from hasAdminPasswordRecoveryUrl's
// older #access_token=...&type=recovery implicit-grant format. This one
// needs an explicit verifyOtp() call; Supabase's client doesn't auto-detect
// it the way it does the hash-based flow.
export function getAdminPasswordRecoveryTokenHash(): string | null {
  if (Platform.OS !== 'web') {
    return null
  }

  const webGlobal = globalThis as WebGlobal
  const search = webGlobal.location?.search
  if (!search) {
    return null
  }

  const params = new URLSearchParams(search)
  if (params.get('type') !== 'recovery') {
    return null
  }

  return params.get('token_hash')
}

export function hasAdminUrlHash() {
  if (Platform.OS !== 'web') {
    return false
  }

  const webGlobal = globalThis as WebGlobal
  return Boolean(webGlobal.location?.hash)
}

export function hasUnknownAdminAuthPath() {
  if (Platform.OS !== 'web') {
    return false
  }

  const webGlobal = globalThis as WebGlobal
  const pathname = webGlobal.location?.pathname

  return Boolean(pathname && pathname !== '/')
}

export function clearAdminAuthUrl() {
  if (Platform.OS !== 'web') {
    return
  }

  const webGlobal = globalThis as WebGlobal
  if (!webGlobal.location) {
    return
  }

  webGlobal.history?.replaceState?.(null, '', '/')
}
